module.exports = __webpack_public_path__ + "img/icon_close.092d115e.svg";